import { Overlay as CarnOverlay } from '@bluebeam/carnivore';

export interface OverlayStorage {
  id: string;
  index: number;
  overlay: CarnOverlay | null;
  overlayCanvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
}

class Overlay {
  id: string;

  index: number;

  _overlay: CarnOverlay | null;

  _overlayCanvas: HTMLCanvasElement;

  ctx: CanvasRenderingContext2D;

  constructor(overlayId: string, index: number) {
    const tempOverlayCanvas = document.createElement('canvas');
    const tempContext = tempOverlayCanvas.getContext(
      '2d'
    ) as CanvasRenderingContext2D;

    this.id = overlayId;
    this.index = index;
    this._overlay = null;
    this._overlayCanvas = tempOverlayCanvas;
    this.ctx = tempContext;
  }

  get overlay(): CarnOverlay | null {
    return this._overlay;
  }

  set overlay(newOverlay: CarnOverlay | null) {
    this._overlay = newOverlay;
    this.overlayCanvas =
      newOverlay?.getCanvas() || document.createElement('canvas');
  }

  get overlayCanvas(): HTMLCanvasElement {
    return this._overlayCanvas;
  }

  set overlayCanvas(newOverlayCanvas: HTMLCanvasElement) {
    this._overlayCanvas = newOverlayCanvas;
    this.ctx = newOverlayCanvas.getContext('2d') as CanvasRenderingContext2D;
  }

  destroy(): void {
    if (this._overlay) {
      this._overlay.destroy();
    }
  }
}

export default Overlay;
